<template>
  <div class="crop-container page-container">
    <v-header></v-header>
    <div class="page-wrap">
      <div class="content">
        <div class="main">
          <div class="side-menu" style="padding:10px 0;">
            <div class="options-block">
              <div class="options">
                <span class="item-label">裁剪方式</span>
                <el-radio-group
                  v-model="cropMode"
                  size="small"
                  @change="changeCropMode"
                >
                  <el-radio-button label="ratio">比例</el-radio-button>
                  <el-radio-button label="size">尺寸</el-radio-button>
                  <!-- <el-radio-button label="shape" disabled>形状</el-radio-button> -->
                </el-radio-group>
              </div>
              <div v-if="cropMode == 'ratio'">
                <common-ratio :cropper="cropper" :currentImage="currentImage"></common-ratio>
              </div>
              <div v-if="cropMode == 'size'">
                <common-size :cropper="cropper" :currentImage="currentImage" @changeCropSize="changeCropSize"></common-size>
              </div>
            </div>

            <div class="button-group operation-button" style="border-top: 1px solid #DCDFE6;margin-top: 5px;">
              <el-button class="cancel-custom" @click="handleCancel" style="margin-top:20px;">重置</el-button>
              <div class="share">
                <v-download :fileList="imageList" @down="down"></v-download>
              </div>
            </div>
          </div>
          <div class="image-main-container">
            <div class="image-editor">
              <div class="editor-wrap" style="display:block;">
                <div class="editor_image">
                  <img :src="currentImage.url" ref="cropperImg" style="object-fit:contain">
                </div>
              </div>
              <div class="upload-tips" v-if="!fileList.length">
                <p>仅支持单图裁剪</p>
                <el-upload
                  action="#"
                  accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                  ref="dynamic"
                  :file-list="fileList"
                  :show-file-list="true"
                  :on-change="handleChanged"
                  :auto-upload="false"
                  :on-remove="handleRemove"
                >
                  <el-button size="large" type="default" class="upload-button">点击上传图片</el-button>
                </el-upload>
              </div>
              
              <div class="image-tips" v-if="currentImage.originalWidth">
                <p>
                  <span>图片的原宽高是: {{currentImage.originalWidth}} x {{currentImage.originalHeight}} , 调整之后的宽高是: </span>
                  <span style="color:#4d90fe">{{this.cropMode == 'size' ? this.cropWidth : currentImage.width || currentImage.originalWidth}} x {{this.cropMode == 'size' ? this.cropHeight : currentImage.height || currentImage.originalHeight}}</span>
                </p>
              </div>
            </div>

            <!-- 图片墙 -->
            <div class="image-list">
              <el-upload
                action="#"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.BMP,.svg"
                ref="dynamic"
                :file-list="fileList"
                :show-file-list="true"
                :on-change="handleChanged"
                :auto-upload="false"
                :on-remove="handleRemove"
              >
                <i class="el-icon-plus"></i>
                <div slot="file" 
                  slot-scope="{file}" 
                  :class="[file.checked ? 'active' : '']"  
                  @click="changeSelected(!file.checked,file)"
                >
                  <img
                    style="width:100%;height:100%;object-fit:contain"
                    :src="file.url"/>
                  <el-checkbox 
                    class="images-checkbox"
                    v-model="file.checked"
                    @change="(value) => changeSelected(!value,file)" 
                    :checked="file.checked"
                  >
                  </el-checkbox>
                  <div class="delete-images" @click.stop="handleRemove(file)">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.min.css';
import commonRatio from './commonRatio';
import commonSize from './commonSize';

export default {
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      fileList: [],

      // 选中当前图片
      currentImage: {
        width: null,
        height: null,
        base64Url: '',
        url: ''
      },
      // 裁剪模式，默认是组件本身带的比例裁剪
      cropMode: 'ratio',
      cropper: '',

      cropWidth: 0,
      cropHeight: 0
    }
  },
  computed: {
    limit () {
      return parseInt(this.IMAGE_LIMIT - this.fileList.length);
    },
    imageList () {
      return this.fileList.filter(item => item.checked == true);
    },
  },

  mounted () {
    this.$nextTick(() => {
      this.initCrop();
    })
    // 当图片容器或裁剪框更改时触发，从而拿到实时的裁剪框的宽高
    this.$refs.cropperImg.addEventListener('crop', (event) => {
      this.currentImage.width = parseInt(event.detail.width)
      this.currentImage.height = parseInt(event.detail.height)
      this.setFileList(this.currentImage);
    });
  },
  
  methods: {
    down () {
      this.applyCrop();
    },

    initCrop () {
      var image = this.$refs.cropperImg; 
      this.cropper = new Cropper(image, { 
        viewMode: 1,
        background: false,
        zoomable: false,
        autoCrop: false,
      });
    },

    changeCropMode (type) {
      this.cropMode = type;
      //将图片尺寸变为原尺寸
      if (!this.currentImage.width) {
          return;
      }
      this.resetImage();
      //  为什么这里使用 reset() 没用？
      // this.cropper.reset();
      // 当切换到常用尺寸的时候需要将比例调为自由，不然出现，输出width,height之后按照之前的比例来进行裁剪
      if (this.cropMode == 'size') {
        this.cropper.setAspectRatio(NaN)
      }
      if (this.cropper){
        this.cropper.destroy();
        this.cropper.replace(this.currentImage.url);
        this.cropper.reset();
      }
    },

    resetImage () {
      // 重置当前图片
      this.currentImage.base64Url = '';
      this.currentImage.width = this.currentImage.originalWidth;
      this.currentImage.height = this.currentImage.originalHeight;
      this.setFileList(this.currentImage);
    },

    resetCropper () {
      // 重置 cropper
      if (this.cropper){
        this.cropper.destroy();
        this.cropper.replace(this.currentImage.url);
        this.cropper.reset();
      }
    },

    applyCrop () {
      let croppedCanvas = this.cropper.getCroppedCanvas();
      if (this.cropMode == 'size') {
        croppedCanvas = this.cropper.getCroppedCanvas({
          width: this.cropWidth,   // 自定义目标宽度
          height: this.cropHeight,  // 自定义目标高度
          imageSmoothingQuality: 'high' // 缩放质量
        });
      }
      
      if (!croppedCanvas) return

      var url = croppedCanvas.toDataURL(this.currentImage.raw.type)
      // 裁剪之后的图片大小
      let croppedData = this.cropper.getData();
      this.currentImage.width = parseInt(this.cropMode == 'size' ? this.cropWidth : croppedData.width);
      this.currentImage.height = parseInt(this.cropMode == 'size' ? this.cropHeight : croppedData.height);
      this.currentImage.base64Url = url;
      this.setFileList(this.currentImage);
    },

    // 自定义取消事件
    handleCancel () {
      this.currentImage.checked = false;
      this.currentImage.width = this.currentImage.originalWidth;
      this.currentImage.height = this.currentImage.originalHeight;
      this.cropWidth = 0;
      this.cropHeight = 0;
      this.setFileList(this.currentImage);
      // 重置会变为原图
      if (this.cropper){
        this.cropper.destroy();
        this.cropper.replace(this.currentImage.url);
      }
      this.cropper.clear();
    },

    // 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    handleChanged (file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]];
      }

      this.currentImage = Object.assign({}, this.fileList[0]);
      this.currentImage.checked = true;
      this.currentImage.isActive = true;
      this.setFileList(this.currentImage);

      this.$readFile(this.currentImage).then(() => {
        this.resetCropper();
        this.initCrop();
      })
    },

    // 上传之前的钩子函数，限定上传图片的格式和大小
    checkImage (file, fileList) {
      let fileType = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      var isImage = this.IMAGE_TYPE_LIMIT.indexOf(fileType) !== -1;
      var isLt10M = file.size / 1024 / 1024 < this.IMAGE_SIZE;

      if (!isImage) {
        this.$message.error('上传图片格式必须为jpg,jepg,png,jpg2,bmp,svg!');
        // return Promise.reject();
        return false;
      }

      if (!isLt10M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.IMAGE_SIZE}MB!`);
        return false;
      }
    },

    //删除
    handleRemove(file) {
      this.fileList.splice(0);
      this.currentImage = {};

      this.cropper.destroy();
      this.cropper.replace('');
      this.cropper.reset();
    },

    // 当图片选中状态变化的时候触发的钩子函数
    changeSelected (value, file) {
      file.checked = value;
      this.currentImage = Object.assign({}, file);
      this.resetImage();

      // 因为只涉及到单图的剪裁，因此取消或者选中都从原图开始
      this.resetCropper();
      this.cropper.clear();
    },

    setFileList (file) {
      this.$set(this.fileList, 0, file);
    },

    selectCurrentImage (value, file) {
      this.fileList.map(item => {
        item.isActive = false;
      })
      file.isActive = true;

      this.currentImage = Object.assign({}, file);
      this.setFileList(file);

      if (!file.checked) {
        this.setTuiImageObject(this.currentImage);
        return;
      }
    },

    changeCropSize(width, height) {
      this.cropWidth = width;
      this.cropHeight = height;
    }
  },
  components: {
    // VueCropper
    commonRatio,
    commonSize,
  },
  
}
</script>

<style lang="scss" scoped>
.crop-container {
  .page-wrap {
    padding: 0px;
    .content {
      .main {
        .image-main-container {
          border-right: 1px solid #eee;

          .editor_image {
            width: 100%;
            height: 100%;
            display: inline-block;
            vertical-align: middle;
            overflow: hidden;

            img {
              max-width:100%;
              display:inline-block;
              height:100%;
              object-fit:contain;
              vertical-align:middle;
            }
          }
        }
        .side-menu {
          /deep/ .el-radio-button--small .el-radio-button__inner {
            padding: 9px 15px;
          }
          .options {
            text-align: left;
            margin-left: 5px;
            margin-bottom: 15px;
          }
        }
        .image-tips {
          width: 100%;
          z-index: 10;
          background-color: #fff;
        }
        
        .upload-tips {
          transform: translate(-50%, -50%);
        }

        .custom-size,
        .custom-ratio {
          div {
            width: 75px;
            display: inline-block;
          }
          .el-input {
            width: 75px;

            /deep/ .el-input__inner {
              height: 35px;
              line-height: 35px;
              padding: 0 10px;
            }
          }
        }
        .custom-ratio {
          padding-bottom: 10px;
        }
        .custom-size {
          padding-bottom: 10px;
        }

        @media screen and (max-height: 820px){
          .side-menu {
            overflow-y: scroll;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/crop/index.vue